export default [
  { path: '', component: () => import('layouts/App'), children: [
    { path: '', component: () => import('layouts/auth/Index'), children: [
      { path: '/', name: 'login', icon: 'genderless', component: () => import('pages/login/Index'), },
      { path: '/login', name: 'login', icon: 'genderless', component: () => import('pages/login/Index'), },
    ], },
    { path: '', component: () => import('layouts/main/Index'), children: [
      { path: '/profile', name: 'profile', title: 'Профиль',
        icon: 'genderless', component: () => import('pages/profile/Index'), },
      { path: '/settings', name: 'settings', title: 'Поддержка',
        icon: 'genderless', component: () => import('../pages/settings/Index'), },
      { path: '/categories', name: 'categories', title: 'Категории',
        icon: 'genderless', component: () => import('../pages/categories/Index'), },
      { path: '/promocodes', name: 'promocodes', title: 'Промокоды',
        icon: 'genderless', component: () => import('../pages/promocodes/Index'), },
      { path: '/users', name: 'users', title: 'Пользователи',
        icon: 'genderless', component: () => import('../pages/users/Index'), },
      { path: '/users/:id', name: 'user-profile', title: 'Пользователь',
        icon: 'genderless', component: () => import('../pages/user-profile/Index'), },
      { path: '/products', name: 'products', title: 'Товары',
        icon: 'genderless', component: () => import('../pages/products/Index'), },
      { path: '/product/create', name: 'product-create', title: 'Создать товар',
        icon: 'genderless', component: () => import('../pages/product-create/Index'), },
      { path: '/products/:id', name: 'product-info', title: 'Товар',
        icon: 'genderless', component: () => import('../pages/product-info/Index'), },
      { path: '/products/:id/edit', name: 'product-edit', title: 'Редактировать товар',
        icon: 'genderless', component: () => import('../pages/product-edit/Index'), },
      { path: '/categories/:id/unber', name: 'unber-category', title: 'Подкатегории',
        icon: 'genderless', component: () => import('../pages/unber-category/Index'), },
      { path: '/promotion-package', name: 'promotion-package', title: 'Пакеты продвижения',
        icon: 'genderless', component: () => import('../pages/promotion-package/Index'), },
      { path: '/messages', name: 'messages', title: 'Сообщения',
        icon: 'genderless', component: () => import('../pages/messages/Index'), },
      { path: '/orders', name: 'orders', title: 'Заказы',
        icon: 'genderless', component: () => import('../pages/orders/Index'), },
      { path: '/lists', name: 'lists', title: 'Списки',
        icon: 'genderless', component: () => import('../pages/lists/Index'), },
      { path: '/list-info/:id', name: 'list-info', title: 'Информация списка',
        icon: 'genderless', component: () => import('../pages/list-info/Index'), },
      { path: '/order/:id', name: 'order-info', title: 'Заказ',
        icon: 'genderless', component: () => import('../pages/order-info/Index'), },
      { path: '/lifestyles', name: 'lifestyles', title: 'LifeStyle',
        icon: 'genderless', component: () => import('../pages/lifestyles/Index'), },
      { path: '/services', name: 'services', title: 'Услуги',
        icon: 'genderless', component: () => import('../pages/services/Index'), },
      { path: '/landing', name: 'landing', title: 'Сайт Ounce',
        icon: 'genderless', component: () => import('../pages/landing/Index'), },
      { path: '/slots', name: 'slots', title: 'Слоты',
        icon: 'genderless', component: () => import('../pages/slots/Index'), },
      { path: '/seller-bid/:id', name: 'seller-bid', title: 'Заявка',
        icon: 'genderless', component: () => import('../pages/seller-bid/Index'), },
      { path: '/avatars', name: 'avatars', title: 'Аватарки',
        icon: 'genderless', component: () => import('../pages/avatars/Index'), },
    ], },
  ], },
]
